const datas = [
  {
    id: '1',
    name: 'data',
    title: 'Program Toko',
    description:
      'Aplikasi toko,software toko ,mesin kasir toko minimarket lengkap barcode system dan touchscreen terbaru.',
    intro: 'Temukan kemudahan dengan menggunakan program toko',
    text: 'Sempurnakan kebutuhan bisnis retail minimarket modern dan toko shop dengan kemudahan dalam bekerja dan fitur yang lengkap untuk menunjang bisnis usaha mu.',
    img: 'https://mesinkasironline.web.app/img/createwebsiteusingreact.png',
    cover: '/cover/programtoko.svg',
    menu1: 'Home',
    menu1url: '/',
    menu2: 'Demo',
    menu2url: '/demo',
    menu3: 'POS',
    menu3url: '/pos',
    menu4: 'Order',
    menu4url: '/order',
    download: 'Download →',
    url: 'https://mesinkasir.github.io/e-catalog/CHROMPOS%20retail.pdf',
  },
];

export default datas;
